import { render, staticRenderFns } from "./help-message-list.vue?vue&type=template&id=e01d3b4e&scoped=true"
import script from "./help-message-list.vue?vue&type=script&lang=js"
export * from "./help-message-list.vue?vue&type=script&lang=js"
import style0 from "./help-message-list.vue?vue&type=style&index=0&id=e01d3b4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01d3b4e",
  null
  
)

export default component.exports